import React, {useEffect, useState,useMemo} from 'react'
import DatePicker from './datePicker'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Select, Stack, TextField } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { getDateRange } from '../navbar/datePopper'
import { setDateRangeToString,getDateRangeFromString, mainTypes, periodTypes } from '../../../common/utils'
const calender1Permissions=[0,1,2,3,6]
const calender2Permissions=[0,6]
const texFieldGridPermissions=[4,5]
const textfieldonlypermissions=[4]
const invertedMainTypes=_.invert(mainTypes)
const invertedPeriodTypes=_.invert(periodTypes)
export function getMaxRange(periodType){
  const weekStart = periodType === 'weekStartMonday' ?'week':periodType==='weekStartSunday'? 'week':periodType;
  const startDate=moment('1-1-2000')
  const endDate=moment()
    return endDate.diff(startDate, weekStart);
}
function getCheckboxLabel(periodType){
  switch(periodType){
    case 0:
      return 'year'
    case 1:
      return 'quarter'
    case 2:
      return 'month'
    case 3:
      return 'week starting Monday'
    case 4:
      return 'week starting Sunday'
    default:
      return 'day'
  }
}
export function isJSON(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

const MainDateSelector = ({setOpenPopper,selectedMain,setSelectedMain,periodLength,setPeriodLength,periodType,setPeriodType,startDate,setStartDate,endDate,setEndDate,range,setRange,disabled=false,width=240}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [dateStart,setDateStart]=useState(new Date())
  const [dateEnd,setDateEnd]=useState(new Date())
  const [error,setError]=useState(0)
  const [included,setIncluded]=useState(true)
  const onChangeMain=(e)=>{
    const {target}=e
    const value=_.parseInt(target.value)
    if(value===5){
      setPeriodLength(1)
    }
    setSelectedMain(value)
    const selectedDate=getDateRange((value===4||value===5||value===2||value===1)?new Date():value===3?moment().startOf('year').toDate():dateStart,value,periodType,periodLength)
    if(selectedDate.startDate){
      setDateStart(selectedDate.startDate)
    }
    if(selectedDate.endDate){
      setDateEnd(selectedDate.endDate)
    }

  }
  const onChangePeriodType=(e)=>{
    const {target}=e
    const value=_.parseInt(target.value)
    setPeriodType(_.parseInt(value))
    const selectedDate=getDateRange((selectedMain===4||selectedMain===5)?new Date():dateStart,selectedMain,value,periodLength)
    if(selectedDate.startDate){
      setDateStart(selectedDate.startDate)
    }
    if(selectedDate.endDate){
      setDateEnd(selectedDate.endDate)
    }
  }
  const onChangePeriodLength=(e)=>{
    const {target}=e
    const value=(_.parseInt(target.value))
    // const value=_.isNaN(_.parseInt(target.value))?1:(_.parseInt(target.value))
    // if(selectedMain===4){
    //     const maxRange=getMaxRange(invertedPeriodTypes[periodType])
    //     if(maxRange<value){
    //       setPeriodLength(value)
    //       return setError(maxRange)
    // }}
    // setError(0)
    setPeriodLength(_.parseInt(value))
    const selectedDate=getDateRange((selectedMain===4||selectedMain===5)?new Date():dateStart,selectedMain,periodType,value)
    if(selectedDate.startDate){
      setDateStart(selectedDate.startDate)
    }
    if(selectedDate.endDate){
      setDateEnd(selectedDate.endDate)
    }
  }
  useEffect(()=>{
    if(startDate&&endDate){
    setDateStart(moment(startDate).toDate())
    setDateEnd(moment(endDate).toDate())
  }
  const rangeObj=getDateRangeFromString(range)
  if(!rangeObj||typeof rangeObj!=='object') return
  const main=rangeObj['mainType']??0
  const pType=rangeObj['periodType']??0
  const pLength=_.isNaN(_.parseInt(rangeObj['days']))?1:_.parseInt(rangeObj['days'])
  const included=rangeObj['included']??false
  setIncluded(included)
  setSelectedMain(main)
  setPeriodType(pType)
  setPeriodLength(pLength)
 },[startDate,endDate,range])


const onDateChange=(date)=>{
  setDateStart(date)
  if(selectedMain===0&&selectedMain===6) return
  const selectedDate=getDateRange(date,selectedMain,periodType,periodLength)
  if(selectedDate.startDate){
    setDateStart(selectedDate.startDate)
  }
  if(selectedDate.endDate){
    setDateEnd(selectedDate.endDate)
  }
}
const applyDates=()=>{
  if(error>0) return
  setStartDate( moment(dateStart).format('YYYY-MM-DDTHH:mm:ss'))
  setEndDate( moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'))
  const rangeString=setDateRangeToString(dateStart,dateEnd,[selectedMain,periodType,periodLength,included])
  setRange(rangeString)
  setOpenPopper(false)
}
useEffect(()=>{
  if(moment(dateStart).isAfter(dateEnd)){
    setDateEnd(new Date())
  }
},[dateStart])
const setIncludedStatus=(e)=>{
  const {target:{checked}}=e
  setIncluded(checked)
  const selectedDate=getDateRange((selectedMain===4||selectedMain===5)?new Date():dateStart,selectedMain,periodType,periodLength,checked)
  if(selectedDate.startDate){
    setDateStart(selectedDate.startDate)
  }
  if(selectedDate.endDate){
    setDateEnd(selectedDate.endDate)
  }
}
const disableDates=useMemo(()=>{
  const isDateAfter=moment(dateStart).isAfter(moment('1-1-2000'))
  if(isDateAfter) return moment(dateStart).toDate()
  return moment('1-1-2000').toDate()
},[dateStart])
  return (<>
  <Stack direction={'row'} spacing={2} alignItems={'flex-start'}>
  <Stack spacing={2} sx={{width:'300px'}}>
  <Select native size='small' value={selectedMain} onChange={onChangeMain} fullWidth>
      <option value={5}>Current</option>
      <option value={4}>Last</option>
      <option value={1}>On</option>
      <option value={3}>After</option>
      <option value={2}>Before</option>
      <option value={0}>Between</option>
      <option value={7}>All Time</option>
    </Select>
    {_.includes(calender1Permissions,selectedMain)&&<DatePicker minDate={moment('1-1-2000').toDate()} date={selectedMain===2?dateEnd:dateStart} onChange={onDateChange}/>}
    </Stack>
   {(selectedMain!==1&&selectedMain!==2&&selectedMain!==3)&&<Stack spacing={2} sx={{width:'300px'}}>
      <Stack direction={'row'} spacing={2} alignItems={'center'}>
        {!_.includes(texFieldGridPermissions,selectedMain)&&<Box sx={{height:'40px'}}></Box>}
      {_.includes(textfieldonlypermissions,selectedMain)&&<TextField error={error>0}  sx={{width:'100px'}}size='small' type='number'  inputProps={{ min: 1 }} value={periodLength} onChange={onChangePeriodLength}/>}
      {_.includes(texFieldGridPermissions,selectedMain)&&<Select native size='small' value={periodType} onChange={onChangePeriodType} fullWidth>
      <option value={0}>{(selectedMain===5||periodLength===1)?'Year':'Years'}</option>
      <option value={1}>{(selectedMain===5||periodLength===1)?'Quarter':'Quarters'}</option>
      <option value={2}>{(selectedMain===5||periodLength===1)?'Month':'Months'}</option>
      <option value={3}>{(selectedMain===5||periodLength===1)?'Week starting Monday':'Weeks starting Monday'}</option>
      <option value={4}>{(selectedMain===5||periodLength===1)?'Week starting Sunday':'Weeks starting Sunday'}</option>
      <option value={5}>{(selectedMain===5||periodLength===1)?'Day':'Days'}</option>
      </Select>
      }
      </Stack>
      {_.includes(calender2Permissions,selectedMain)&&<DatePicker minDate={disableDates} date={dateEnd} onChange={setDateEnd}/>}
      {/* {!_.includes(calender2Permissions,selectedMain)&&<Box sx={{height:'260px',opacity:0,visibility:'hidden'}}/>} */}
    </Stack>}
  </Stack>
  <Stack pt={2} direction={'row'} spacing={2} alignItems={'center'} sx={{maxWidth:(selectedMain!==1&&selectedMain!==2&&selectedMain!==3)?'616px':'300px'}} justifyContent={'flex-end'}>
    {selectedMain===4&&<FormControlLabel control={<Checkbox checked={included} onChange={e=>setIncludedStatus(e)}/>} label={`Include current ${getCheckboxLabel(periodType)}`}/>}
    <Button size='small' variant='contained' color='primary' onClick={applyDates}>Apply</Button>
  </Stack>
  </>
  )
}

export default MainDateSelector